import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import CardAnimatedHome from '../CardAnimatedHome'

import bg1 from '../../resourses/home1.webp'
import bg2 from '../../resourses/home2.webp'
import bg3 from '../../resourses/home3.webp'

import CirclesHome from '../CirclesHome'

const HomeContent1 = ({ cardHandler, width }) => {
    const [heroVisible, setHeroVisible] = React.useState(false)
    const isMobile = width < 768

    const carouselHandler = () => {
        const img1 = document.getElementById("carousel-img-1")
        const img2 = document.getElementById("carousel-img-2")
        const img3 = document.getElementById("carousel-img-3")

        if (img1.classList.contains("bg-home-in")) {
            img1.classList.replace("bg-home-in", "bg-home-out")
            img2.classList.add("bg-home-in")
            img3.classList.remove("bg-home-out")
        } else if (img1.classList.contains("bg-static-home")) {
            img1.classList.replace("bg-static-home", "bg-home-out")
            img2.classList.add("bg-home-in")
            img3.classList.remove("bg-home-out")
        } else if (img2.classList.contains("bg-home-in")) {
            img2.classList.replace("bg-home-in", "bg-home-out")
            img3.classList.add("bg-home-in")
            img1.classList.remove("bg-home-out")
        } else if (img3.classList.contains("bg-home-in")) {
            img3.classList.replace("bg-home-in", "bg-home-out")
            img1.classList.add("bg-home-in")
            img2.classList.remove("bg-home-out")
        }
    }

    React.useEffect(() => {
        const interval = setInterval(() => {
            carouselHandler()
        }, 6000)

        return () => clearInterval(interval)
    }, [])

    React.useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 20) {
                setHeroVisible(true)
            } else {
                setHeroVisible(false)
            }
        }

        window.addEventListener("scroll", handleScroll)
        return () => window.removeEventListener("scroll", handleScroll)
    }, [])

    // Padding superior reducido para dar aire exacto respecto al Header
    const contStyle = {
        paddingTop: isMobile ? "120px" : "130px"
    }

    return (
        <>
            <div id="homeContainer" className="mt-sm-5 pb-5 mt-md-0">
                {/* Carrusel de imágenes */}
                <div className="carousel-container-home">
                    <img id="carousel-img-1" className="img-as-bg bg-home-in" src={bg1} alt="" />
                    <img id="carousel-img-2" className="img-as-bg" src={bg2} alt="" />
                    <img id="carousel-img-3" className="img-as-bg bg-home-out" src={bg3} alt="" />
                </div>

                {/* Overlay que aparece al hacer scroll */}
                <div className={`home-hero-overlay ${heroVisible ? "home-hero-overlay-visible" : ""}`}></div>

                {/* Contenido principal del Hero */}
                <div className={`hero-main-content ${heroVisible ? "hero-main-content-visible" : ""}`}>
                    <Container style={contStyle}>
                        <Row>
                            <Col md={11} className="text-left">
                                <h5
                                    className="blue-bg bold mb-3"
                                    style={{
                                        width: "max-content",
                                        backgroundColor: "#EDE9E4",
                                        borderRadius: "0 30px 0px 30px",
                                        padding: "8px 24px",
                                        color: "#958434",
                                    }}
                                >
                                    {" La calidad es nuestra prioridad"}
                                </h5>

                                {width >= 1200 ? (
                                    <h1 className="white hero-title">
                                        Cuidamos cada operación como si fuera propia
                                        <br />
                                        Responsabilidad, compromiso y atención
                                        <br />
                                        en cada paso
                                    </h1>
                                ) : (
                                    <div className="title-container-home">
                                        <h2 className="bold white">
                                            Cuidamos cada operación como si fuera propia
                                        </h2>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>

            {/* En Desktop/Tablet (>= 768px) las cards/círculos van en una sección debajo del Hero, en una sola fila */}
            {!isMobile && (
                <div className="hero-cards-section py-5">
                    <Container>
                        <div className="d-flex justify-content-center align-items-center flex-nowrap hero-cards-row">
                            {width >= 1200 ? (
                                <CardAnimatedHome cardHandler={cardHandler} />
                            ) : (
                                <CirclesHome width={width} />
                            )}
                        </div>
                    </Container>
                </div>
            )}

            {/* En Mobile (< 768px) los círculos pasan a estar inmediatamente abajo del Hero */}
            {isMobile && (
                <div className="circles-home-mobile-section py-4 px-3">
                    <CirclesHome width={width} />
                </div>
            )}
        </>
    )
}

export default HomeContent1